module.exports = __webpack_public_path__ + "static/img/lotte.f2fe075.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/lotte.jpg
// module id = c6Co
// module chunks = 0